<div class="number">
    <span *ngFor="let item of clock$ | async"
          [ngClass]="['bg', 'num', 'num-' + item]">
    </span>
</div>